import React from "react";
import BottleGrid from "./bottle-grid";
import BottleForm from "./bottle-form";
import BottleToolbar from "./bottle-toolbar";
import AuthorizedComponent from "../authorized-component";
import { AuthContext, AuthContextType } from "../../hooks";
import { alertError, confirm2, enums, notifySuccess } from "../../base";
import { bottleService } from "../../api";
import { ContentBlock, DeletedBottleImportPopup } from "../../components";
import { BottleBatchModel, BottleModel } from "../../models";

export default class BottlePage extends AuthorizedComponent {
    objectName = "Bottle";
    gridRef = React.createRef<BottleGrid>();
    formRef = React.createRef<BottleForm>();
    toolbarRef = React.createRef<BottleToolbar>();
    importPopupRef = React.createRef<DeletedBottleImportPopup>();

    constructor(props: any) {
        super(props);

        this.onBottleSelected = this.onBottleSelected.bind(this);
        this.onRowChecked = this.onRowChecked.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);
        this.onBatchButtonClick = this.onBatchButtonClick.bind(this);
        this.onSaved = this.onSaved.bind(this);
        this.onFiltering = this.onFiltering.bind(this);
    }

    onBottleSelected(bottle: BottleModel) {
        this.toolbarRef.current?.setModel(bottle);
    }

    onRowChecked(bottles: BottleBatchModel[]) {
        this.toolbarRef.current?.setBatchModels(bottles);
    }

    onButtonClick(bottle: BottleModel, name: string) {
        switch (name) {
            case "edit":
                if (this.permissions[enums.stdActions.update]) {
                    this.formRef.current?.show(bottle);
                }
                break;

            case "add":
                if (this.permissions[enums.stdActions.create]) {
                    this.formRef.current?.show({});
                }
                break;

            case "importdeleted":
                if (this.permissions[enums.stdActions.delete]) {
                    this.importPopupRef.current?.show();
                }
                break;
        }
    }

    onBatchButtonClick(bottles: BottleBatchModel[], name: string) {
        switch (name) {
            case "del":
                if (this.permissions[enums.stdActions.delete]) {
                    this.switchDeleteStatus(bottles);
                    break;
                }
        }
    }

    async switchDeleteStatus(bottles: BottleBatchModel[]) {
        if (!bottles.length || !(await confirm2(`确定要${bottles[0].deleted ? "恢复" : "注销"}这些气瓶吗？`))) {
            return;
        }

        const deleted = bottles[0].deleted;
        const ids = bottles.map(b => b.id);
        const result = deleted ? await bottleService.restore(ids) : await bottleService.logicDelete(ids);

        if (result.succeeded) {
            await this.gridRef.current?.gridRef.current?.instance.refresh();
            this.toolbarRef.current?.setBatchModels(this.gridRef.current?.getSelectedBottles() || []);
        } else {
            alertError(result.message ?? "");
        }
    }

    onSaved() {
        this.gridRef.current &&
            this.gridRef.current.gridRef.current?.instance.refresh();
    }

    async delete(e: any) {
        if (!await confirm2("确定要删除吗？")) {
            return;
        }

        const res = await bottleService.delete(e.data.id);

        if (res.succeeded) {
            this.gridRef.current?.refresh();
            notifySuccess("成功删除记录");
        } else {
            alertError(res.message!);
        }
    }

    onFiltering(filterValue: any[], isPorcelainCode?: boolean) {
        this.gridRef.current?.specialFilter(filterValue, isPorcelainCode);
    }

    render() {
        return <AuthContext.Consumer>
            {context => this.renderMain(context)}
        </AuthContext.Consumer>
    }

    renderMain(context: AuthContextType) {
        return (
            <ContentBlock caption={"钢瓶档案"}>
                <BottleToolbar
                    permissions={this.permissions}
                    ref={this.toolbarRef} 
                    user={context.user}
                    onButtonClick={this.onButtonClick}
                    onBatchButtonClick={this.onBatchButtonClick}
                    onFiltering={this.onFiltering} />
                <BottleGrid 
                    ref={this.gridRef} 
                    user={context.user} 
                    onBottleSelected={this.onBottleSelected}
                    onRowChecked={this.onRowChecked}
                    onButtonClick={this.onButtonClick} />
                <BottleForm ref={this.formRef} onSaved={this.onSaved} />
                <DeletedBottleImportPopup ref={this.importPopupRef} onSaved={this.onSaved} />
            </ContentBlock>
        );
    }
}